import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';

const ShowMenuTypeModal = ({ isOpen, toggle, menuType }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Menu Type Details</ModalHeader>
      <ModalBody>
        <Table>
          <tbody>
            <tr>
              <th>ID</th>
              <td>{menuType.id}</td>
            </tr>
            <tr>
              <th>Name (English)</th>
              <td>{menuType.translations.find(t => t.locale === 'en')?.name || '-'}</td>
            </tr>
            <tr>
              <th>Name (Arabic)</th>
              <td>{menuType.translations.find(t => t.locale === 'ar')?.name || '-'}</td>
            </tr>
            <tr>
              <th>Created At</th>
              <td>{new Date(menuType.created_at).toLocaleString()}</td>
            </tr>
            <tr>
              <th>Updated At</th>
              <td>{new Date(menuType.updated_at).toLocaleString()}</td>
            </tr>
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ShowMenuTypeModal;
